<template>
    <el-dialog
        :width="signChangeRefuseConfig.width"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :before-close="beforeClose"
        :close-on-press-escape="false"
        :title="signChangeRefuseConfig.dialogTitle"
        :custom-class="'performanceSignInDialog'"
        top="5vh"
    >
        <div
            class="signContent"
            v-loading="signLoading"
        >
            <div class="signLeft">
                <p class="upload-top-title" v-if="CNStateSubsidies">全部回单</p>
                <receipt-upload
                    ref="receiptUpload"
                    :attachmentList="attachmentList"
                    :rowData="rowData"
                    :loading="attachmentLoading"
                    :operateType="signChangeRefuseConfig.operateType"
                    @handleChangeFlag="handleChangeFlag($event)"
                    @delete-success="deleteReceiptImageSuccess"
                    @upload-success="uploadReceiptImageSuccess"
                ></receipt-upload>
                
                <p class="upload-top-title" v-if="CNStateSubsidies">SN码</p>
                <sn-upload
                    ref="snUpload"
                    v-if="CNStateSubsidies"
                    :attachmentList="snUploadList"
                    :rowData="rowData"
                    :loading="attachmentLoading"
                    :operateType="dialogConfig.operateType"
                    @delete-success="deleteReceiptImageSuccess"
                    @upload-success="uploadReceiptImageSuccess"
                ></sn-upload>

                <p class="upload-top-title" v-if="CNStateSubsidies">货物正面照</p>
                <goods-upload
                    ref="goodsUpload"
                    v-if="CNStateSubsidies"
                    :attachmentList="goodsUploadList"
                    :rowData="rowData"
                    :loading="attachmentLoading"
                    :operateType="dialogConfig.operateType"
                    @delete-success="deleteReceiptImageSuccess"
                    @upload-success="uploadReceiptImageSuccess"
                ></goods-upload>
            </div>
            <div class="signRight">
                <sign-in-form
                    ref="signInForm"
                    :goodsList="goodsList"
                    :viewStatus="viewStatus"
                ></sign-in-form>

                <sign-change-refuse-table
                    ref="signInTable"
                    v-if="+viewStatus === 1"
                    :rowData="rowData"
                    :kaType="receiptInfo.kaType"
                    :tableDataList="tableDataList"
                    :operateType="signChangeRefuseConfig.operateType"
                    @setCount="getCount"
                ></sign-change-refuse-table>

                <sign-Change-refuse-CNTable
                    v-if="+viewStatus === 4"
                    ref="CNSignInTable"
                    :rowData="rowData"
                    :kaType="receiptInfo.kaType"
                    :tableDataList="tableDataList"
                    @setCount="getCount"
                ></sign-Change-refuse-CNTable>
            </div>
        </div>
        <template #footer>
            <el-button @click="beforeClose">取消</el-button>
            <el-button
                type="primary"
                :loading="btnLoading"
                @click="handleSignChangeRefuseConfirm"
                >签改拒确认</el-button
            >
        </template>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
import SignInForm from './SignInForm.vue';
import ReceiptUpload from '../ReceiptUpload.vue';
import snUpload from '../snUpload.vue';
import goodsUpload from '../goodsFrontUpload.vue';
import { attachmentEntity } from '../../entity.js';
import signChangeRefuseTable from './signChangeRefuseTable.vue';
import signChangeRefuseCNTable from './signChangeRefuseCNTable.vue';
import {
    getReceiptSignDetailInfo,
    queryReceiptDetailByTaskNo,
    receiptChangeReject
} from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { OPERATE_TYPE } from '../utils/constant.js';
import { formatSingleSignRequestParams } from './util.js';

export default {
    name: 'signChangeRefuse',
    components: {
        ReceiptUpload,
        snUpload,
        goodsUpload,
        SignInForm,
        signChangeRefuseTable,
        signChangeRefuseCNTable
    },
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        signChangeRefuseConfig: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            OPERATE_TYPE,
            viewStatus: '', // table组件展示标识
            btnLoading: false, // 签收、拒收确认按钮加载动画
            attachmentLoading: false,
            receiptInfo: {}, // 回单签收表单信息
            attachmentList: [], // 附件列表
            snUploadList: [], // SN码附件列表
            goodsUploadList: [], // 货物正面照附件列表
            tagList: [],
            goodsList: [],
            currentView: 'sign',
            signLoading: false,
            warehouseDataInfo: {}, // 入库数据信息
            tableDataList: [], // table组件参数
            componentChange: {
                1: 'signInTable',
                4: 'CNSignInTable'
            } // table组件名称标识
        };
    },
    computed: {
        ...mapState(['user']),
        CNStateSubsidies () {
            return this.rowData.isSubsidies === '1';
        }
    },
    methods: {
        /**
         * @description 获取左侧附件列表
         */
        getAttachmentList () {
            this.attachmentLoading = true;
            attachmentEntity.getAttachmentList(this.rowData.id).then(list => {
                this.attachmentList = list;
                this.$nextTick(() => {
                    this.$refs.receiptUpload.show();
                });
                if (this.CNStateSubsidies) {
                    // defineStr2: 普通照片--"0";SN码照片--"1";货物正面照--"2"
                    this.snUploadList = list.filter(item => item.defineStr2 === '1');
                    this.goodsUploadList = list.filter(item => item.defineStr2 === '2');
                    this.$nextTick(() => {
                        this.$refs.snUpload.show();
                        this.$refs.goodsUpload.show();
                    });
                }
            }).finally(() => { this.attachmentLoading = false; });
        },

        /**
         * @description 获取签收详情
         */
        getReceiptSignDetailInfo () {
            getReceiptSignDetailInfo({
                taskNo: this.rowData.taskNo // 运输单号
            }).then(res => {
                if (res && +res.code === 0) {
                    this.receiptInfo = Object.assign({}, { currentUserName: this.user.userName }, this.rowData, res.data);
                    this.$refs.signInForm.initFormData(this.receiptInfo);
                }
            }).finally(() => {
                this.getReceiptSignDetailList();
            });
        },

        /**
         * @description 获取签收详情列表
         */
        getReceiptSignDetailList () {
            queryReceiptDetailByTaskNo({ taskNo: this.rowData.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    this.tableDataList = res.data.details || [];
                    this.goodsList = res.data.details || [];
                    this.viewStatus = res.data.customPilotType;
                }
            });
        },
        /* 处理汇总变化 */
        getCount (data) {
            this.goodsList = data;
            this.$forceUpdate();
        },

        /**
         * @description 图片上传成功回调
         */
        uploadReceiptImageSuccess () {
            this.getAttachmentList();
            this.$emit('uploadAttachmentSuccess');
        },

        /**
         * @description 删除图片成功回调
         */
        deleteReceiptImageSuccess () {
            this.getAttachmentList();
            this.$emit('deleteAttachmentSuccess');
        },

        /**
         * @description 签改拒确认
         */
        handleSignChangeRefuseConfirm () {
            const componentName = this.componentChange[this.viewStatus];
            this.$refs[componentName].validateDataIsTrue().then(tableData => {
                this.btnLoading = true;
                const reqParams = formatSingleSignRequestParams(this.receiptInfo, tableData, OPERATE_TYPE.REJECT_COMFIRM);
                reqParams.receiptSignDto.id = this.rowData.id; // 当前操作行数据id
                reqParams.rejectReason = ''; // 拒收原因 暂时传空
                reqParams.signRemark = ''; // 拒收备注 暂时传空
                receiptChangeReject(reqParams).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('签改拒成功');
                        this.$emit('success', 'signChangeRefuseShow');
                    }
                }).finally(() => {
                    this.btnLoading = false;
                });
            }).catch(({ message }) => {
                this.$message.warning(message);
            });
        },

        beforeClose () {
            this.$emit('update:signChangeRefuseShow', false);
        },

        initSignin () {
            this.getAttachmentList();
            this.getReceiptSignDetailInfo();
        },
        addListener() {
            this.$nextTick(() => {
                document.onkeydown = e => {
                    if (e.code === 'Escape') {
                        const receiptViewer = this.$refs.receiptUpload.viewer && this.$refs.receiptUpload.viewer.fulled;
                        const snViewer = this.$refs.snUpload && this.$refs.snUpload.viewer && this.$refs.snUpload.viewer.fulled;
                        const goodsViewer = this.$refs.goodsUpload && this.$refs.goodsUpload.viewer && this.$refs.goodsUpload.viewer.fulled;
                        if (!(receiptViewer || snViewer || goodsViewer)) {
                            this.beforeClose();
                        }
                    }
                };
            });
        }
    },
    mounted () {
        this.addListener();
        this.initSignin();
    },
    unmounted() {
        // 移除事件监听器
        this.$nextTick(() => {
            document.onkeydown = null;
        });
    }
};
</script>
<style lang="less">
@import url('./signIn.less');
</style>
